import { Route, Routes } from "react-router-dom";
import storage from "../../helpers/storage";
import { AllPayment } from "./List/List";
import { View } from "./View/View";

export const Payment = () => {
  storage.setPageTitle("Payment History");
  return (
    <Routes>
      <Route path="/" element={<AllPayment />} />
      <Route path="/view/:id" element={<View />} />
    </Routes>
  );
};
